import React, {useState} from "react";
import * as S from './styles'

type TabsProps = {
    children: React.ReactElement<TabProps>[]
    activeKey: string
}

type TabProps = {
    name: string
    label: string
    children: JSX.Element[] | JSX.Element | String
}

type TabMenuItem = {
    name: string
    label: string
    isActive: boolean
    activate: Function
}

export const Tabs = ({children, activeKey}: TabsProps) => {
    const [active, setActive] = useState(activeKey);

    let content;
    const buttons = React.Children.map(children, (child, idx) => {
        if (React.isValidElement(child)) {
            const isActive = active === child.props.name;
            if (isActive) {
                content = React.createElement(TabContent, {children: child.props.children})
            }

            const props = {isActive, name: child.props.name, label: child.props.label, activate: setActive};
            return React.createElement(TabMenuItem, props);
        }
        return child;
    });

    return (
        <S.Tabs>
            <S.TabsMenu>{buttons}</S.TabsMenu>
            <S.TabsContent>{content}</S.TabsContent>
        </S.Tabs>
    )
}

export const Tab = ({}: TabProps) => {return (<></>)}

const TabMenuItem = ({name, label, isActive, activate}: TabMenuItem) => {
    const onClick = () => activate(name);

    return (
        <S.TabMenuItem onClick={onClick} isActive={isActive}>
            {label}
        </S.TabMenuItem>
    )
}

const TabContent = ({children}) => {
    return (
        <div>
            {children}
        </div>
    )
}